import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

@Injectable()
export class AttendeeService extends BaseService {
  constructor(
    protected override http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendees`);
  }

  validateAttendees(urlParams: any, formData): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/validate_attendees`, urlParams);
    return this.http.post<any>(url, formData);
  }

  importAttendees(urlParams: any, formData): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/import_attendees`, urlParams);
    return this.http.post<any>(url, formData);
  }

  // POC: ask the backend AI to clean AND reformat raw uploaded rows (split/parse/
  // standardize values) into the given template columns.
  reformatImportRows(targetColumns: string[], rawRows: any[]): Observable<{ rows: any[]; warnings: string[]; guardedDropped: number }> {
    const url = `${environment.apiBaseUrl}/bedrock/attendee-import/reformat`;
    return this.http.post<{ rows: any[]; warnings: string[]; guardedDropped: number }>(url, { targetColumns, rawRows });
  }

  /** attendee_sign route uses contact_id in the path segment, not attendee row id */
  updateSignature(
    urlParams: { company_id: string; event_id: string; contact_id: string },
    payload: { signature?: string; signature_meta?: unknown; signature_on_paper?: boolean },
  ): Observable<any> {
    const url = sprintf(
      `${environment.apiBaseUrl}/companies/%(company_id)s/events/%(event_id)s/attendee_sign/%(contact_id)s`,
      urlParams,
    );
    return this.http.put<any>(url, payload);
  }
}
